import { Currency } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { select } from '@swf/core/store';
import { PrizeType } from '@swf/core/types/CasinoRaces';

interface Props {
  type?: PrizeType;
  currency?: Currency;
  amount: number;
}

const letterValue = (amount: number) => {
  switch (true) {
    case amount / 1000000 >= 1:
      return { letter: 'M', amount: amount / 1000000 };
    case amount / 1000 >= 1:
      return { letter: 'K', amount: amount / 1000 };
    default:
      return { letter: '', amount };
  }
};

// TODO: refactor from Brainfuck into Typescript. This betwise is not readable
// eslint-disable-next-line no-bitwise
const hasDecimal = (amount: number) => amount - ~~amount >= 0.01;

const PrizeCurrency: React.FC<Props> = ({
  type = PrizeType.CASH,
  currency = Currency.USDollar,
  amount
}) => {
  const isMobile = useSelector(select.device.isMobile);
  const wholeAmount: number = type === PrizeType.FSB ? amount : amount / 100;
  const { amount: roundedAmount, letter } = letterValue(wholeAmount);

  switch (true) {
    case type === PrizeType.NONE:
      return <span>–</span>;
    case type === PrizeType.FSB:
      // TODO: we shouldn't use Fragment just because type workaround

      return <>{wholeAmount}</>;
    case isMobile && !!letter:
      return (
        <CurrencyAmount
          value={Math.floor(roundedAmount * 100)} // rules: no round up/down, show max 2 decimals
          currency={currency}
          maximumFractionDigits={2}
          minimumFractionDigits={0}
        >
          {(parts) => `${parts.reduce((prev, part) => prev + part.value, '')}${letter}`}
        </CurrencyAmount>
      );
    case hasDecimal(wholeAmount):
      return <CurrencyAmount value={amount} currency={currency} />;
    default:
      return (
        <CurrencyAmount
          value={amount}
          currency={currency}
          maximumFractionDigits={0}
          minimumFractionDigits={0}
        />
      );
  }
};

export default PrizeCurrency;
